<ng-container *ngIf="unreadCount$ | async as unreadCount; else notUnreadCountIcon">
  <div class="sm:block hidden">
    <i
      class="pi pi-bell p-text-secondary cursor-pointer hover:frm-color-blue lk-eu-header__utility-icon"
      pBadge
      [value]="unreadCount?.toString()"
      severity="danger"
      (click)="openNotificationSidebar()"></i>
  </div>

  <div class="sm:hidden block">
    <i
      class="pi pi-bell p-text-secondary cursor-pointer hover:frm-color-blue lk-eu-header__utility-icon"
      pBadge
      [value]="unreadCount?.toString()"
      severity="danger"
      (click)="menu.toggle($event)"></i>
  </div>
</ng-container>

<ng-template #notUnreadCountIcon>
  <div class="sm:block hidden">
    <i
      class="pi pi-bell p-text-secondary cursor-pointer hover:frm-color-blue lk-eu-header__utility-icon"
      (click)="openNotificationSidebar()"></i>
  </div>

  <div class="sm:hidden block">
    <i
      class="pi pi-bell p-text-secondary cursor-pointer hover:frm-color-blue lk-eu-header__utility-icon"
      (click)="menu.toggle($event)"></i>
  </div>
</ng-template>

<p-menu
  #menu
  [popup]="true"
  [model]="menuItems"
  appendTo="body"
  styleClass="lk-eu-menubar">
</p-menu>
